module.exports = __webpack_public_path__ + "static/media/RouteMobile-Logo.1ca61812.webp";